module.exports = __webpack_public_path__ + "media/packs/images/flags/AD-c3cde1264c9c612501386a45082dc3fa.svg";